import React from 'react';
import {
  GlobeAltIcon,
  TruckIcon,
  ExclamationTriangleIcon,
  AcademicCapIcon,
  ShieldCheckIcon,
  ArrowPathIcon,
  CpuChipIcon,
  ClipboardDocumentCheckIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';
import { IndustryPageTemplate } from '../../components/page-templates/MarketPageTemplates';

const challenges = [
  {
    icon: UserGroupIcon,
    title: 'Large-Scale Device Deployments',
    description: 'Rolling out thousands of devices across campuses, classrooms, and research facilities simultaneously.',
  },
  {
    icon: GlobeAltIcon,
    title: 'Global Device Programmes',
    description: 'Managing student and faculty device programmes across international campuses and partner institutions.',
  },
  {
    icon: ExclamationTriangleIcon,
    title: 'Budget-Conscious Operations',
    description: 'Maximising device lifecycle value and optimising logistics spend within tight institutional budgets.',
  },
  {
    icon: ShieldCheckIcon,
    title: 'Research Equipment Handling',
    description: 'Specialised research equipment requiring careful cross-border handling and customs compliance.',
  },
];

const solutions = [
  {
    icon: TruckIcon,
    title: 'Bulk Device Fulfilment & Staging',
    description: 'High-volume device procurement, staging, and delivery coordinated to match your academic calendar.',
  },
  {
    icon: GlobeAltIcon,
    title: 'IOR/EOR for International Campuses',
    description: 'Full import/export compliance for shipping equipment to campuses and facilities in 140+ countries.',
  },
  {
    icon: CpuChipIcon,
    title: 'Device Imaging & Pre-Configuration',
    description: 'At-scale device imaging with your institutional software, security policies, and network settings.',
  },
  {
    icon: ClipboardDocumentCheckIcon,
    title: 'Asset Lifecycle Management',
    description: 'Complete tracking from procurement through deployment to end-of-life across your entire fleet.',
  },
  {
    icon: ShieldCheckIcon,
    title: 'Certified Data Wiping',
    description: 'NIST 800-88 compliant data destruction for end-of-life devices, protecting student and research data.',
  },
  {
    icon: ArrowPathIcon,
    title: 'Reverse Logistics for Refresh Programmes',
    description: 'Coordinated device collection, refurbishment assessment, and recycling for technology refresh cycles.',
  },
];

const stats = [
  { value: '140+', label: 'Countries' },
  { value: '6', label: 'Global Offices' },
  { value: '10+', label: 'Years Experience' },
  { value: '6,500+', label: 'Field Workers' },
];

const EducationResearch: React.FC = () => (
  <IndustryPageTemplate
    eyebrow="Education & Research"
    title="ICT Logistics for Education & Research Institutions"
    highlight="Education & Research"
    description="Supporting universities, schools, and research organisations with reliable global ICT equipment deployment and lifecycle management."
    heroIcon={AcademicCapIcon}
    heroAccentIcon={GlobeAltIcon}
    challengesIntro="Educational institutions face unique logistics demands driven by scale, budgets, and global operations."
    challenges={challenges}
    solutionsIntro="Execution support for device programmes, research equipment, and lifecycle operations across academic environments."
    solutions={solutions}
    useCase="Whether it is a campus-wide laptop deployment or equipping a new international research facility, TrueLog scales ICT logistics to match your academic mission."
    stats={stats}
    ctaTitle="Ready to simplify ICT logistics for your institution?"
    ctaDescription="Let TrueLog scale your device programmes and research logistics so you can focus on education and discovery."
  />
);

export default EducationResearch;
